import{useEffect}from"react";/*
 * Calls callback in an effect and renders children
 */export function FireCallbackInEffect(_ref){let{children,callback}=_ref;useEffect(()=>{callback();});return children;}